import { IconType } from "react-icons/lib";
import { TbCar, TbChecks, TbCircleOff, TbClock, TbPlaneArrival, TbPlaneDeparture } from "react-icons/tb";

// Brightness1RoundedIcon
import { softColors } from "./colors";
import { TaskStatuses } from "./status";

export type TaskStatusItem = {
    status: TaskStatuses;
    component: () => IconType;
    bg: string;
    hover: string;
    label: string;
    text: string;
    tooltip: {
        title: string;
        description: string;
    };
};

export const taskStatuses: TaskStatusItem[] = [
    {
        status: TaskStatuses.PENDING,
        component: () => TbClock,
        ...softColors.brown,
        label: "taskStatuses.PENDING",
        tooltip: {
            title: "taskStatuses.PENDING",
            description: "taskStatuses.PENDING_DESC",
        },
    },
    {
        status: TaskStatuses.STARTED,
        component: () => TbCar,
        ...softColors.deepPurple,
        label: "taskStatuses.STARTED",
        tooltip: {
            title: "taskStatuses.STARTED",
            description: "taskStatuses.STARTED_DESC",
        },
    },
    {
        status: TaskStatuses.ARRIVED_FROM,
        component: () => TbPlaneArrival,
        ...softColors.purple,
        label: "taskStatuses.ARRIVED_FROM",
        tooltip: {
            title: "taskStatuses.ARRIVED_FROM",
            description: "taskStatuses.ARRIVED_FROM_DESC",
        },
    },
    {
        status: TaskStatuses.ON_ROUTE,
        component: () => TbPlaneDeparture,
        ...softColors.indigo,
        label: "taskStatuses.ON_ROUTE",
        tooltip: {
            title: "taskStatuses.ON_ROUTE",
            description: "taskStatuses.ON_ROUTE_DESC",
        },
    },
    {
        status: TaskStatuses.DONE,
        component: () => TbChecks,
        ...softColors.green,
        label: "taskStatuses.DONE",
        tooltip: {
            title: "taskStatuses.DONE",
            description: "taskStatuses.DONE_DESC",
        },
    },
    {
        status: TaskStatuses.CANCELED,
        component: () => TbCircleOff,
        ...softColors.red,
        label: "taskStatuses.CANCELED",
        tooltip: {
            title: "taskStatuses.CANCELED",
            description: "taskStatuses.CANCELED_DESC",
        },
    },
];
